import { writable } from 'svelte/store';
import { persistedWritable } from './persistedWritable';

export const isGlobalSearchOpen = writable(false);

export const searchIncludeDone = persistedWritable('globalSearch:includeDone', false);
export const searchIncludeArchived = persistedWritable('globalSearch:includeArchived', false);
export const searchIncludeBacklog = persistedWritable('globalSearch:includeBacklog', true);

export function openGlobalSearch() {
  isGlobalSearchOpen.set(true);
}

export function closeGlobalSearch() {
  isGlobalSearchOpen.set(false);
}

export function toggleGlobalSearch() {
  isGlobalSearchOpen.update((open) => !open);
}
